export const API_ = "https://crm.development.consultified.com/api";
export const SERVER_ = "https://crm.development.consultified.com/";
export const SOCKET_ = "https://crm.development.consultified.com";
export const SITE_API_ = "https://development.consultified.com/api";
export const SITE_SERVER_ = "https://development.consultified.com/";
export const SITE_SOCKET_ = "https://development.consultified.com";
export const FILE_BASE_URL_ = "https://storage.cloud.google.com/consultified_media/";

